<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:GlobalHeader
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.02.00 | 2022/11/14 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.04.00 | 2023/04/26 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.05.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div id="nav">
		<!-- header -->
		<header
			:id="isAuthority == true ? 'header__head--wrap-staff' : 'header__head--wrap'"
			:class="{ open:isOpen }"
			class="header"
		>
			<div class="inner">
				<div id="header__mobile--head">
					<h1 class="logo">
						{{ viewTitle }}
					</h1>
					<div
						v-if="isAuthenticated"
						id="header__nav--toggle"
						@click="openMenu"
					>
						<div>
							<span />
							<span />
							<span />
						</div>
					</div>
					<div
						v-else
						id="header__nav--toggle-nonauth"
						@click="openMenu"
					>
						<div>
							<span />
							<span />
							<span />
						</div>
					</div>
				</div>
				<nav
					v-if="isAuthenticated"
					id="header__global--nav"
				>
					<ul>
						<li
							v-if="!isAuthority"
							class="contents__padding--inquiry"
						>
							<font-awesome-icon :icon="['far','question-circle']" />&nbsp;<span v-html="inquiryMessage" />
						</li>
						<li v-if="isMenu">
							<a @click="clickReturnMenu">
								<font-awesome-icon icon="bars" />&nbsp;メニューへ戻る
							</a>
						</li>
						<li>
							<a @click="clickLogOutMenu">
								<font-awesome-icon icon="sign-out-alt" />&nbsp;ログアウト
							</a>
						</li>
					</ul>
				</nav>
				<nav
					v-else
					id="header__global--nav-nonauth"
				>
					<ul>
						<li
							v-if="!isAuthority"
							class="contents__padding--inquiry"
						>
							<font-awesome-icon :icon="['far','question-circle']" />&nbsp;<span v-html="inquiryMessage" />
						</li>
						<li v-if="isLogin">
							<a @click="clickLoginMenu">
								<font-awesome-icon icon="sign-in-alt" />&nbsp;ログイン
							</a>
						</li>
						<li>
							<a @click="clickSystemShutdown">
								<font-awesome-icon icon="sign-out-alt" />&nbsp;終了
							</a>
						</li>
					</ul>
				</nav>
			</div>
		</header>
		<div id="header__main--visual" />
		<!-- /header -->
	</div>
</template>

<script>
import { co_post } from '@/common/ajaxUtility.js';
import { co_confirmDialog } from '@/common/dialogUtility.js';
import { co_doLogout } from '@/common/logoutEventUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_toTrans } from '@/common/screenUtility';
import { ROLE_TYPE, DIALOG_BUTTON_LIST_KEY, ZUIJI_JYUTAKU } from '@/const/const.js';
import { STORE_VIEW_GET_TITLE, STORE_VIEW_GET_NAME, STORE_USER_IS_AUTHENTICATED, STORE_USER_GET_INFO,
			STORE_DATA_GETDATA, STORE_DATA_DELETE_AT, STORE_DATA_DELETE_ALL, STORE_VIEW_CLEAR_PAGE,
			STORE_VIEW_CLEAR_VIEW_PARAMS } from '@/const/store.js';
import { API_ZUIJI_KAIHO_KOSU, API_CAUTION_ITEMS } from '@/const/route.js';

export default {
	data() {
		return {
			// メニュー表示
			isOpen:false,
			zuijiInfo:[],		// 随時募集情報
			moveKbn: '',		// 画面遷移フラグ
			inquiryMessage: '',	// 問合せ
		};
	},
	computed: {
		// 画面タイトル
		viewTitle: function() {
			return this.$store.getters[STORE_VIEW_GET_TITLE];
		},
		// メニュー表示フラグ
		isMenu: function() {
			let isMenu = true;
			if (this.$store.getters[STORE_VIEW_GET_NAME] === 'BC002'
				|| this.$store.getters[STORE_VIEW_GET_NAME] === 'BrowserError') {
					isMenu = false;
			}
			return isMenu;
		},
		// ログイン認証済みフラグ
		isAuthenticated: function() {
			return this.$store.getters[STORE_USER_IS_AUTHENTICATED];
		},
		// 管理者権限有無フラグ
		isAuthority: function() {
			let isAuthority = false;
			let userInfo = this.$store.getters[STORE_USER_GET_INFO];
			if (ROLE_TYPE.TOKYOTO_STAFF === userInfo.role) {
					isAuthority = true;
			}
			return isAuthority;
		},
		// ログイン表示フラグ
		isLogin: function() {
			let isLogin = false;
			let screenId = this.$store.getters[STORE_VIEW_GET_NAME];
			if (screenId === 'BC005'
				|| screenId === 'BC006'
				|| screenId === 'BC007') {
					isLogin = true;
			}
			return isLogin;
		}
	},
	created: async function() {

		// 問合せ注意文生成
		this.createInquiryTyuibun();

	},
	methods: {
		// メニューオープン
		openMenu: function () {
			this.isOpen = this.isOpen ? false : true;
		},
		// メニュー遷移処理
		clickReturnMenu: function () {

			this.isOpen = false;

			// 随時募集用の状態管理（ストア）が存在する場合
			this.zuijiInfo = this.$store.getters[STORE_DATA_GETDATA](ZUIJI_JYUTAKU);
			if (this.zuijiInfo != null) {
				// 残戸数管理処理
				this.moveKbn = '1';
				co_confirmDialog(co_getMessage('W0020'), this.zuijiProc);
			} else {
				// メニューに遷移
				co_toTrans('BC002');
			}
		},
		// ログアウト処理
		clickLogOutMenu: function () {

			this.isOpen = false;

			// 随時募集用の状態管理（ストア）が存在する場合
			this.zuijiInfo = this.$store.getters[STORE_DATA_GETDATA](ZUIJI_JYUTAKU);
			if (this.zuijiInfo != null) {
				// 残戸数管理処理
				this.moveKbn = '2';
				co_confirmDialog(co_getMessage('W0020'), this.zuijiProc);
			} else {
				// ログアウト実行
				co_doLogout();

				// ログインに遷移
				co_toTrans('BC001');
			}
		},
		// システム終了処理
		clickSystemShutdown: function () {

			this.isOpen = false;

			window.location.href = 'https://www.juutakuseisaku.metro.tokyo.lg.jp/toei_online/index.html';
		},
		// ログイン処理
		clickLoginMenu: function () {

			this.isOpen = false;

			// 画面保持情報クリア
			this.$store.commit(STORE_DATA_DELETE_ALL);
			this.$store.commit(STORE_VIEW_CLEAR_PAGE);
			this.$store.commit(STORE_VIEW_CLEAR_VIEW_PARAMS);

			// ログインに遷移
			co_toTrans('BC001');
		},
		// 残戸数管理処理（随時募集）
		zuijiProc: async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// 残戸数を解放
				let param = {
					'kbBosyu'		: this.zuijiInfo.bosyuKind.substring(0, 2),
					'kbZyutaku'		: this.zuijiInfo.jyutakuKind,
					'ymBosyu'		: this.zuijiInfo.ymBosyu,
					'noMouchiku'	: this.zuijiInfo.noMouchiku
				};
				await co_post(API_ZUIJI_KAIHO_KOSU, param);

				//募集住宅情報（随時募集）の状態管理情報を削除
				this.$store.commit(STORE_DATA_DELETE_AT, ZUIJI_JYUTAKU);

				if (this.moveKbn == '1') {
					// メニューに遷移
					co_toTrans('BC002');
				} else if (this.moveKbn == '2') {
					// ログアウト実行
					co_doLogout();

					// ログインに遷移
					co_toTrans('BC001');
				}
			}
		},
		// 問合せ注意文生成
		createInquiryTyuibun: async function () {

			let params = {tyuibunList: ["C0248"]};
			let val = await co_post( API_CAUTION_ITEMS, params );

			let viewMessage = '';			// 画面表示用メッセージ

			if ( val != null ) {
				for ( let i = 0; i < val.length; i++ ) {
					let sentenceList = [];		// メッセージリスト
					let message = [];			// 画面表示用メッセージ
					let lkMessage = '';			// 画面表示用リンクメッセージ
					let lkUrl = '';				// 外部リンクURL

					sentenceList = val[i].messageNaiyo.split(/\r\n|\n/);
					for ( let j = 0; j < sentenceList.length; j++ ) {
						if (sentenceList[j].indexOf('%A'+ (i)) >= 0) {
							let list = sentenceList[j].split('%A0S');
							message.push(list[0]);
							lkMessage = list[1].replace('%A0E', '');
						} else {
							message.push(sentenceList[j]);
						}
					}

					// URLリンク生成
					if (!co_isEmpty(val[i].lkUrl)) {
						let lkUrlList = val[i].lkUrl.split(/\r\n|\n/);
						for (let i = 0; i < lkUrlList.length; i++) {
							lkUrl = lkUrlList[i].split('：')[1];
						}
					}

					viewMessage = '<label>' + message;
					viewMessage = viewMessage + '<a href="' + lkUrl + '" class="contents__link--inquiry" target="_blank" rel="noopener noreferrer" tabindex="-1">' + lkMessage + '</a>';
					viewMessage = viewMessage + '</label>';

					this.inquiryMessage = viewMessage;
				}
			}
		}
	},
};
</script>

<style scope>
</style>